module.exports = __webpack_public_path__ + "static/scale-model-of-yellowstone-art-museum-in-billings-montana-6a42f329a651f77858b0bdc7cfdb1d73.png";